/* eslint-disable */
// 是否微信
export function is_weixin() {
  var ua = navigator.userAgent
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    isMobile = isIphone || isAndroid
  if (isMobile) {
    if (ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}
// 是否QQ
export function is_qq() {
  var _UA = window.navigator.userAgent;
  if(/QQ\/\d/i.test(_UA)){
    return true;
  }
  return false;
}
// 字符串转十六进制
export function strToHexCharCode(str) {
  if (str === '') return ''
  var hexCharCode = []
  for (var i = 0; i < str.length; i++) {
    hexCharCode.push(str.charCodeAt(i).toString(16))
  }
  return hexCharCode.join('')
}

/**
 * 字符串脱敏
 * @param {*} str 字符串
 * @param {*} beginLen 符串前面保留位数
 * @param {*} endLen 字符串后面保留位数
 * @returns string
 */
export function desensitization(str, beginLen, endLen) {
  beginLen = beginLen ? beginLen : 1
  endLen = endLen ? endLen : 1
  var len = str.length - beginLen - endLen
  var xing = ''
  for (var i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, beginLen) + xing + str.substring(str.length - endLen)
}

// 校验手机号
export function checkPhone(val) {
  let str = `${val}`
  if (str.length == 11 && str.indexOf('1') == 0) {
    return true
  }
  return false
}

// 校验身份证号
export function checkIdCard(val) {
  var checkID = function (val) {
    if (checkCode(val)) {
      var date = val.substring(6, 14)
      if (checkDate(date)) {
        if (checkProv(val.substring(0, 2))) {
          return true
        }
      }
    }
    return false
  }
  // 校验校验码
  var checkCode = function (val) {
    var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
    var code = val.substring(17)
    if (p.test(val)) {
      var sum = 0
      for (var i = 0; i < 17; i++) {
        sum += val[i] * factor[i]
      }
      if (parity[sum % 11] == code.toUpperCase()) {
        return true
      }
    }
    return false
  }
  // 校验出生日期
  var checkDate = function (val) {
    var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/
    if (pattern.test(val)) {
      var year = val.substring(0, 4)
      var month = val.substring(4, 6)
      var date = val.substring(6, 8)
      var date2 = new Date(year + '-' + month + '-' + date)
      if (date2 && date2.getMonth() == parseInt(month) - 1) {
        return true
      }
    }
    return false
  }
  // 校验省级地址码
  var checkProv = function (val) {
    var pattern = /^[1-9][0-9]/
    var provs = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门'
    }
    if (pattern.test(val)) {
      if (provs[val]) {
        return true
      }
    }
    return false
  }
  if (checkID(val)) {
    return true
  }
  return false
}

/**
 * 日期格式化
 * @param {string} time 时间: 系统时间、时间戳
 * @param {string} pattern 返回格式: {y}-{m}-{d} {h}:{i}:{s}
 * @returns 返回: 2021-08-02 00:00:00
 */
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
